<template>
 <div>
   <component :is="$matchComponent('base-test')"></component>
   <el-button @click="openGridSelect">openGridSelect</el-button>
   <!-- <grid-select-dialog :dialogVisible="showGridSelect" @close="showGridSelect = false" :tableData="GridData" :multiple="true" sortBy='' @selectData="selectData"></grid-select-dialog> -->
   <!-- tab -->
   <!-- <chip-reaction-tab :samples="scanData"></chip-reaction-tab> -->
   <el-button @click="opentReport">opent reprot review</el-button>
    <review-report-iframe :isDialog="showReport" :sampleId="sampleId" @closeDialog="showReport=false"></review-report-iframe>

    <el-button @click="showDialog = true">Open</el-button>
    <show-handle-result-dialog @updateVisible="updateVisible" :dialogVisible="showDialog" :isShowReason="true" :table-data="gridData">
    </show-handle-result-dialog>
    <!-- 鼠标滚动获取数据 -->

    <!-- <el-table :data='tableData' stripe style="width: 100%" :height="380" class="infinite-table" v-loading="loading">
      <el-table-column prop="chineseName" label="中文名称">
      </el-table-column>
      <el-table-column prop="englishName" label="英文名称">
      </el-table-column>
      <el-table-column prop="tags" label="标签">
        <template slot-scope="scope">
          <el-button type="primary" round  size="mini" v-for="(tag,index) in scope.row.tags" :key="index" style="cursor:default">{{tag}}</el-button>
        </template>
      </el-table-column>
      <template slot="append">
        <infinite-loading @updateLoading="updateLoading" :onRequestData="onRequestData" ref="infinite" :distance="10" force-wrapper=".el-table__body-wrapper" parent-dom=".infinite-table">
        </infinite-loading>
      </template>
    </el-table> -->
    <el-button @click="downTest">dd</el-button>
 </div>
</template>

<script>
import infiniteLoading from 'cps/base/infinite-loading'
import showHandleResultDialog from 'cps/lab-order/show-handle-result-dialog'
import reviewReportIframe from 'cps/lab-order/order-status/form/components/review-report-iframe'
// import gridSelect from 'cps/base/pt-grid-select/index'
// import gridSelectDialog from 'cps/lab-order/selector/grid-select-dialog'
// import chipReactionTab from 'cps/lab-order/selector/chip-reaction-tab'
export default {
  data () {
    return {
      showDialog: false,
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }],
      pageSize: 10,
      currentParams: {},
      tableData: [],
      loading: false,
      showReport: false,
      sampleId: 'MCL-NEW01',
      showGridSelect: false,
      GridData: [{
        rowIndex: 'RA',
        'C01': 'R01C01'
      }, {
        rowIndex: 'RH',
        'C02': 'R01C01'
      }, {
        rowIndex: 'RB'
      }, {
        rowIndex: 'RC',
        'C02': 'RCC02'
      }, {
        rowIndex: 'RE'
      }, {
        rowIndex: 'RD'
      }, {
        rowIndex: 'RG'
      }, {
        rowIndex: 'RF'
      }],
      scanData: [{
        labCode: 'CG-V001CG-V001CG-V001CG-V001',
        reactionNum: 2
      }, {
        labCode: 'CG-V002',
        reactionNum: 2
      }, {
        labCode: 'CG-V003',
        reactionNum: 2
      }, {
        labCode: 'CG-V004',
        reactionNum: 2
      }, {
        labCode: 'CG-V005',
        reactionNum: 2
      }]
    }
  },
  components: {
    showHandleResultDialog,
    infiniteLoading,
    reviewReportIframe,
    // gridSelect,
    // gridSelectDialog,
    // chipReactionTab
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
    },
    updateLoading (val) {
      this.loading = val
    },
    buildFilterParams (page) {
      return {
        page: page,
        size: this.pageSize,
        category: 'COMMON_DISEASES',
        getAllConfigs: false,
        getCorpus: false,
        sort: 'id,desc'
      }
    },
    onRequestData (page, next) {
      let data = this.buildFilterParams(page)
      this.$store.dispatch('getDetectionListByFilter', data).then(res => {
        next(res.data)
        if (res.data.length) {
          this.tableData = this.tableData.concat(res.data)
        }
      }).catch(err => {
        this.$refs.infinite.showReTry()
        this.$message.error(err)
      })
    },
    opentReport () {
      this.showReport = true
    },
    // gridSelect---
    openGridSelect () {
      this.showGridSelect = true
    },
    selectData (data) {
      console.log(data)
    },
    downTest () {
      this.$store.dispatch('downloadTestExcel').catch(error => {
        this.$message.error(error)
      })
    }
  }
}
</script>

<style>

</style>
